import { nodesFlux } from '@candulabs/craft';
import React from 'react';

import { BuiltInComponents } from 'craft/constants';
import { Section } from 'craft/containers/Toolbox/components';
import { useEditorSelector } from 'craft/hooks';
import { useFlowAncestor } from 'craft/state';

import { FlowActionButtons } from './FlowActionButtons';
import { SaveProgressToggle } from './SaveProgressToggle';

const FlowToolboxImpl = React.memo(({ nodeId }: { nodeId: string }) => {
  return (
    <Section name="Flow Settings">
      <SaveProgressToggle nodeId={nodeId} />
      <FlowActionButtons nodeId={nodeId} />
    </Section>
  );
});

interface Props {
  nodeIds: string[];
}

export const FlowToolbox = React.memo(({ nodeIds }: Props) => {
  const { flowNodeId } = useFlowAncestor((nodeIds || [])[0]);
  const nodeType = useEditorSelector(nodesFlux.selectors.getNodeName((nodeIds || [])[0]));

  if (nodeType !== BuiltInComponents.Flow && nodeType !== BuiltInComponents.FlowStep) {
    // only show flow settings when Flow or Flow step are selected
    return null;
  }

  return <FlowToolboxImpl nodeId={flowNodeId || nodeIds[0]} />;
});
